<template>
  <div class="container justify-content-center mt-5 company-payment-page">
    <div class="row mb-5">
      <div class="col-12 form1">
        <div class="row d-flex justify-content-center">
          <div class="col-md-6">
            <div class="mb-4">
              <dashboard-item fa="id-card-o" :contentItems="subscriptionContentItems" :title="$t(LangConstants.my_subscription_title)" :text="$t(LangConstants.subscription_payment_helper_text)" bgvariant="blue" textvariant="dark"></dashboard-item>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-4">
              <dashboard-item fa="users" :contentItems="participantContentItems" :title="$t(LangConstants.participants_title)" :text="$t(LangConstants.participant_invoice_helper_text)" bgvariant="grey" textvariant="dark" actionbuttontext="" actionbuttonroute="/"></dashboard-item>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h4>{{ $t(LangConstants.company_profile_menu_item) }}</h4>
    <div class="container-fluid mt-3 mb-5 form-base">
      <b-form ref="frmOrderCompanyCreate" @submit.stop.prevent="processCompanyProfileUpdate" class="pl-1 pr-1">
        <div class="row">
          <div class="col-md-6">
            <my-input id="email" name="email" :label="$t(LangConstants.company_email_input_label)" placeholder="help@theboringcompany.com" inlinerows="false" classes="bg-gray" type="email" ref="companyEmail" :defaultText="companyFormObject.email" v-model="companyFormObject.email" :error="companyFormObject$.email.$error == true ? companyFormObject$.email.$errors[0].$message : ''"></my-input>
          </div>
          <div class="col-md-6">
            <my-input id="company-no" name="company-no" :label="$t(LangConstants.company_number_input_label)" placeholder="1231232" inlinerows="false" classes="bg-gray" ref="orgNumber" :defaultText="companyFormObject.organization_number" v-model="companyFormObject.organization_number" :error="companyFormObject$.organization_number.$error == true ? companyFormObject$.organization_number.$errors[0].$message : ''"></my-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <my-input id="company-name" name="company-name" :label="$t(LangConstants.company_name_input_label)" placeholder="The Boring Company" inlinerows="false" classes="bg-gray" ref="companyname" :defaultText="companyFormObject.name" v-model="companyFormObject.name" :error="companyFormObject$.name.$error == true ? companyFormObject$.name.$errors[0].$message : ''"></my-input>
          </div>
          <div class="col-md-6">
            <my-input id="phone" name="phone" :label="$t(LangConstants.phone_input_label)" placeholder="+333333332222" inlinerows="false" classes="bg-gray" ref="companyPhone" :defaultText="companyFormObject.phone" v-model="companyFormObject.phone" :error="companyFormObject$.phone.$error == true ? companyFormObject$.phone.$errors[0].$message : ''"></my-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-4">
              <my-button fa="floppy-o" :label="$t(LangConstants.save_changes_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit"></my-button>
            </div>
            <!-- <<<<<<< HEAD
          </div>
        </div>
      </b-form>
    </div>

    <h4>{{ $t(LangConstants.invoice_approval_heading) }}</h4>
    <div class="container-fluid mt-3 mb-5 form-base">
      <no-data-box v-if="!invoices || invoices.length == 0">
        <h5>
          {{ $t(LangConstants.no_invoice_message) }}
        </h5>
      </no-data-box>
      <b-table-simple borderless small responsive class="pl-2 pr-2" v-if="invoices && invoices.length > 0">
        <b-thead>
          <b-tr>
            <b-th class="p-0"><my-button :label="$t(LangConstants.date_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortInvoicesByDate()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.order_details_label)" variant="sort" height="56px" width="100%" classes="btn-inline-text" type="button"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.name_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortInvoicesByName()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.email_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortInvoicesByEmail()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.organization_number_label)" variant="sort" height="56px" width="100%" classes="btn-inline-text" type="button" fa="sort" fapos="right" @onClick="sortInvoicesByOrgNumber()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.options_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text"></my-button></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="invoice in filteredInvoices" :key="invoice.id">
            <b-td class="p-2 pt-3 pl-3">{{ dayjs(invoice.created_at).format("DD-MM-YYYY") }}</b-td>
            <b-td class="p-2 pl-3"><my-button label="View Order" variant="solid-grey" classes="btn-inline-text" @onClick="showViewOrderModal(invoice.id)"></my-button></b-td>
            <b-td class="p-2 pt-3 pl-3">{{ invoice.buyer.first_name + " " + invoice.buyer.last_name }}</b-td>
            <b-td class="p-2 pt-3 pl-3">{{ invoice.buyer.email }}</b-td>
            <b-td class="p-2 pt-3 pl-3">{{ getFieldFromObject(invoice.buyer.company, 'organization_number')  }}</b-td>

            <b-td class="p-2">
              <div class="d-flex nowrap" v-if="invoice.status == 'pending'">
                <my-button :label="$t(LangConstants.approve_btn_label)" variant="solid-primary" fa="check" @onClick="approveInternalInvoice(invoice.id)"></my-button>
                <my-button :label="$t(LangConstants.decline_btn_label)" variant="solid-grey" fa="ban" classes="ml-2" @onClick="declineInternalInvoice(invoice.id)"></my-button>
              </div>
              <div class="d-flex nowrap" v-if="invoice.status == 'pending_card_payment'">
                {{ $t(LangConstants.pending_card_payment_label) }}
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="row mt-2" v-if="invoices && invoices.length > 0">
        <div class="mx-auto">
          <pagination :rows="invoices.length" :perPage="invoiceItemsPerPage" class="" ariacontrols="courses-list" @change="handlePageChangeForInvoice" align="center" />
        </div>
      </div>
      <b-modal id="view-order-modal" :title="$t(LangConstants.order_details_label)" hide-footer>
        <div class="row form-base order-info-entitites pl-3 pr-3 mb-2" v-if="this.selectedOrderToView">
          <div class="col-md-12 order-info-entity mb-4">
            <span class="header">{{ $t(LangConstants.course_title_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.webshop_payment_items[0].webshop.course.name }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.quantity_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.quantity }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.total_text) }}</span>
            <span class="value">{{ this.selectedOrderToView.total && this.selectedOrderToView.currency ? formatMoney(this.selectedOrderToView.total, this.selectedOrderToView.currency) : null }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.purchaser_name_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.first_name + " " + this.selectedOrderToView.buyer.last_name }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.email_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.email }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.organization_name_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.company }}</span>
          </div>

======= -->
          </div>
        </div>
      </b-form>
    </div>
    <h4>{{ $t(LangConstants.invoice_approval_heading) }}</h4>
    <div class="container-fluid mt-3 mb-5 form-base">
      <no-data-box v-if="!invoices || invoices.length == 0">
        <h5>
          {{ $t(LangConstants.no_invoice_message) }}
        </h5>
      </no-data-box>
      <b-table-simple borderless small responsive class="pl-2 pr-2" v-if="invoices && invoices.length > 0">
        <b-thead>
          <b-tr>
            <b-th class="p-0"><my-button :label="$t(LangConstants.date_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortInvoicesByDate()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.order_details_label)" variant="sort" height="56px" width="100%" classes="btn-inline-text" type="button"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.name_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortInvoicesByName()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.email_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text" fa="sort" fapos="right" @onClick="sortInvoicesByEmail()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.organization_number_label)" variant="sort" height="56px" width="100%" classes="btn-inline-text" type="button" fa="sort" fapos="right" @onClick="sortInvoicesByOrgNumber()"></my-button></b-th>
            <b-th class="p-0"><my-button :label="$t(LangConstants.options_label)" variant="sort" height="56px" width="100%" type="button" classes="btn-inline-text"></my-button></b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="invoice in filteredInvoices" :key="invoice.id">
            <b-td class="p-2 pt-3 pl-3">{{ dayjs(invoice.created_at).format("DD-MM-YYYY") }}</b-td>
            <b-td class="p-2 pl-3"><my-button :label="$t(LangConstants.view_order_label)" variant="solid-grey" classes="btn-inline-text" @onClick="showViewOrderModal(invoice.id)"></my-button></b-td>
            <b-td class="p-2 pt-3 pl-3">{{ invoice.buyer.first_name + " " + invoice.buyer.last_name }}</b-td>
            <b-td class="p-2 pt-3 pl-3">{{ invoice.buyer.email }}</b-td>
            <b-td class="p-2 pt-3 pl-3">{{ getFieldFromObject(invoice.buyer.company, "organization_number") }}</b-td>
            <b-td class="p-2">
              <div class="d-flex nowrap" v-if="invoice.status == 'pending'">
                <my-button :label="$t(LangConstants.approve_btn_label)" variant="solid-primary" fa="check" @onClick="approveInternalInvoice(invoice.id)"></my-button>
                <my-button :label="$t(LangConstants.decline_btn_label)" variant="solid-grey" fa="ban" classes="ml-2" @onClick="declineInternalInvoice(invoice.id)"></my-button>
              </div>
              <div class="d-flex nowrap" v-if="invoice.status == 'pending_card_payment'">
                {{ $t(LangConstants.pending_card_payment_label) }}
              </div>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <div class="row mt-2" v-if="invoices && invoices.length > 0">
        <div class="mx-auto">
          <pagination :rows="invoices.length" :perPage="invoiceItemsPerPage" class="" ariacontrols="courses-list" @change="handlePageChangeForInvoice" align="center" />
        </div>
      </div>
      <b-modal id="view-order-modal" :title="$t(LangConstants.order_details_label)" hide-footer>
        <div class="row form-base order-info-entitites pl-3 pr-3 mb-2" v-if="this.selectedOrderToView">
          <div class="col-md-12 order-info-entity mb-4">
            <span class="header">{{ $t(LangConstants.course_title_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.webshop_payment_items[0].webshop.course.name }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.quantity_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.quantity }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.total_text) }}</span>
            <span class="value">{{ this.selectedOrderToView.total && this.selectedOrderToView.currency ? formatMoney(this.selectedOrderToView.total, this.selectedOrderToView.currency) : null }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.purchaser_name_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.first_name + " " + this.selectedOrderToView.buyer.last_name }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.email_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.email }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.organization_name_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.company ? this.selectedOrderToView.buyer.company.name : "" }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.organization_number_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.company.organization_number }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.invoicing_address_input_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.company.address }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.city_input_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.company.city }}</span>
          </div>
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.zip_code_input_label) }}</span>
            <span class="value">{{ this.selectedOrderToView.buyer.company.postal_code }}</span>
          </div>

          <div class="col-12">
            <my-button :label="$t(LangConstants.close_button_label)" variant="outline-primary" classes="mt-4" height="56px" width="100%" @onClick="hideViewOrderModal()"></my-button>
          </div>
        </div>
      </b-modal>
    </div>
    <div class="mt-3 mb-5">
      <order-list :orders="orders" v-if="loadedOrders"></order-list>
    </div>
  </div>
</template>

<script>
/**
 * Subscription Page
 */

import MyInput from "../../components/atoms/Input.vue";
import MyButton from "../../components/atoms/Button.vue";
import Pagination from "../../components/atoms/Pagination.vue";
import NoDataBox from "../../components/atoms/NoDataBox.vue";

import useValidate from "@vuelidate/core";
import { required, email /*, helpers */ } from "@vuelidate/validators";
import { reactive } from "@vue/composition-api";

import DashboardItem from "../../components/organisms/DashboardItem.vue";
import OrderList from "../../components/organisms/OrderList.vue";

import "../../assets/scss/common.scss";
import "../../assets/scss/company-account-subscription.scss";
import common from "../../functions/index";
import Constants from "../../constants/index";

const dayjs = require("dayjs");

export default {
  name: "company-subscription",
  async beforeCreate() {},
  async created() {
    try {
      const webshopPayments = await this.$store.dispatch("getAllOwnWebshopPayment");
      const pedingInvoicePayments = webshopPayments.data.filter((payment) => payment.method == "invoice_internal" && (payment.status == "pending" || payment.status == "pending_card_payment") && payment.buyer);
      this.invoices = pedingInvoicePayments;
      const olderPayments = webshopPayments.data.filter((payment) => (payment.status == "success" && payment.buyer) || payment.method == "woocommerce_integration");
      this.orders = olderPayments;

      this.loadedOrders = true;

      await this.syncWebShopPayments();
      this.splitInvoiceContent();
    } catch (error) {
      this.$fire({
        title: this.$t(this.LangConstants.customer_profile_retrieval_error_heading),
        text: this.$t(this.LangConstants.customer_profile_retrieval_status_heading),
        type: "error",
        html: "<div>" + this.$t(error) + "</div>",
      }).then(() => {});
    }

    await this.$store
      .dispatch("getCustomerSubscription")
      .then((response) => {
        this.customerSubscription = response["subscription"];
        this.subscriptionContentItems.push({
          title: this.customerSubscription.subscription.title,
          text: this.$store.getters.instanceUrl,
          type: "url",
        });
        this.participantContentItems.push({
          title: response["last_30_days_student_count"],
          text: this.$t(this.LangConstants.new_participants_per_month_text),
          type: "text",
          icon: "fa-arrow-up",
          iconVariant: "success",
        });
        this.participantContentItems.push({
          title: response["total_students_count"],
          text: this.$t(this.LangConstants.participants_all_time_text),
          type: "text",
          icon: "fa-arrow-up",
          iconVariant: "success",
        });
      })
      .catch((error) => {
        this.$fire({
          title: this.$t(this.LangConstants.subscription_status_error_heading),
          text: this.$t(this.LangConstants.subscription_status_error_message),
          type: "error",
          html: "<div>" + this.$t(error) + "</div>",
        }).then(() => {});
      });

    await this.$store
      .dispatch("getCustomer")
      .then((customer) => {
        this.companyFormObject.id = customer["id"];

        this.$refs.companyEmail.text = customer["email"];
        this.$refs.companyname.text = customer["name"];
        this.$refs.orgNumber.text = customer["organization_number"];
        this.$refs.companyPhone.text = customer["phone"];

        this.companyFormObject.email = customer["email"];
        this.companyFormObject.name = customer["name"];
        this.companyFormObject.organization_number = customer["organization_number"];
        this.companyFormObject.phone = customer["phone"];
      })
      .catch((error) => {
        this.$fire({
          title: this.$t(this.LangConstants.customer_profile_retrieval_error_heading),
          text: this.$t(this.LangConstants.customer_profile_retrieval_status_heading),
          type: "error",
          html: "<div>" + this.$t(error) + "</div>",
        }).then(() => {});
      });
  },

  setup() {
    const companyFormObject = reactive({
      id: null,
      email: "",
      organization_number: "",
      name: "",
      phone: "",
    });

    const companyFormObjectRules = {
      email: { required, email },
      organization_number: { required },
      name: { required },
      phone: { required },
    };

    const companyFormObject$ = useValidate(companyFormObjectRules, companyFormObject);

    return {
      companyFormObject,
      companyFormObject$,
    };
  },
  data() {
    return {
      customerSubscription: null,
      invoices: [],
      filteredInvoices: [],
      invoiceItemsPerPage: 10,
      currentInvoicePage: 1,
      orders: [],
      sortedInvoicesByDate: false,
      sortedInvoicesByName: false,
      sortedInvoicesByOrgNumber: false,
      sortedInvoicesByEmail: false,
      selectedOrderToView: null,
      subscriptionContentItems: [],
      participantContentItems: [],
      loadedOrders: false,
    };
  },

  methods: {
    getFieldFromObject(object, fieldName) {
      if (object != null && object[fieldName] != undefined) {
        return object[fieldName];
      }
      return "N/A";
    },

    async syncWebShopPayments() {},

    async approveInternalInvoice(internalInvoiceId) {
      this.$store
        .dispatch("approveWebshopPayment", { id: internalInvoiceId })
        .then((result) => {
          if (result.success == true) {
            const payment = this.invoices.find((payment) => payment.id == internalInvoiceId);
            if (payment) {
              payment.status = "success";
              this.invoices = this.invoices.filter((payment) => payment.method == "invoice_internal" && (payment.status == "pending" || payment.status == "pending_card_payment") && payment.buyer && payment.id != internalInvoiceId);
              this.orders.push(payment);
              // this.filterOrders();
              this.handlePageChangeForInvoice(this.currentInvoicePage);
              // this.handlePageChangeForOrders(this.currentOrderPage);
            }
          }

          this.$fire({
            title: this.$t(result.message),
            // text: this.$t(result.success),
            type: "success",
          }).then(() => {});
        })

        .catch((error) => {
          this.$fire({
            title: this.$t(this.LangConstants.customer_profile_update_status_heading),
            text: this.$t(this.LangConstants.customer_profile_update_error_message),
            type: "error",
            html: "<div>" + this.$t(error) + "</div>",
          }).then(() => {});
        });
    },

    async declineInternalInvoice(internalInvoiceId) {
      this.$store

        .dispatch("declineWebshopPayment", { id: internalInvoiceId })
        .then((result) => {
          if (result.success == true) {
            console.log(internalInvoiceId);
            const payment = this.invoices.find((payment) => payment.id == internalInvoiceId);
            if (payment) {
              payment.status = "pending_card_payment";
            }
          }

          let order = this.invoices.filter((payment) => payment.method == "invoice_internal" && payment.status == "pending_card_payment" && payment.id == internalInvoiceId);

          order = order[0];

          this.$store
            .dispatch("createWebshopPaymentInquiry", {
              to_address: order["buyer"]["email"], // training manager email address
              template_id: "27977494",
              template_parameters: {
                product_url: "https://sparkfore.com",
                product_name: order["webshop_payment_items"][0]["webshop"]["course"]["name"],
                name: order["buyer"]["first_name"] + " " + order["buyer"]["last_name"],
                action_url: this.$store.getters.spInstanceVueURL + "company-account/webshop/continue/payment/" + order["id"] + "/" + order["instance_id"],
                support_url: "https://sparkfore.com",
                company_name: "company_name_Value",
                company_address: "company_address_Value",
                invoice_id: String(order["id"]).padStart(6, "0"),
                date: dayjs(order.created_at).format("DD-MM-YYYY"),
              },
            })
            .then(() => {
              this.$fire({
                title: this.$t(result.message),
                // text: this.$t(result.success),
                type: "success",
              }).then(() => {});
            });

          //
        })
        .catch((error) => {
          this.$fire({
            title: this.$t(this.LangConstants.customer_profile_update_status_heading),
            text: this.$t(this.LangConstants.customer_profile_update_error_message),
            type: "error",
            html: "<div>" + this.$t(error) + "</div>",
          }).then(() => {});
        });
    },

    async processCompanyProfileUpdate() {
      this.companyFormObject$.$validate();
      const validated = this.companyFormObject$.$error == true ? false : true;
      if (validated == true) {
        this.$store
          .dispatch("updateOwnCustomer", { customer: this.companyFormObject })
          .then(() => {
            this.$fire({
              title: this.$t(this.LangConstants.customer_profile_update_success_heading),
              text: this.$t(this.LangConstants.customer_profile_update_success_message),
              type: "success",
            }).then(() => {});
          })
          .catch((error) => {
            this.$fire({
              title: this.$t(this.LangConstants.customer_profile_update_status_heading),
              text: this.$t(this.LangConstants.customer_profile_update_error_message),
              type: "error",
              html: "<div>" + this.$t(error) + "</div>",
            }).then(() => {});
          });
      }
    },

    handlePageChangeForInvoice(page) {
      this.currentInvoicePage = page;
      this.splitInvoiceContent();
    },

    splitInvoiceContent() {
      this.filteredInvoices = this.invoices.slice((this.currentInvoicePage - 1) * this.invoiceItemsPerPage, this.currentInvoicePage * this.invoiceItemsPerPage);
    },

    resetInvoiceList() {
      this.currentInvoicePage = 1;
      this.splitInvoiceContent();
    },

    sortInvoicesByDate() {
      if (this.sortedInvoicesByDate == true) {
        this.invoices.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      } else {
        this.invoices.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      }
      this.sortedInvoicesByDate = this.sortedInvoicesByDate == true ? false : true;
      this.resetInvoiceList();
    },

    sortInvoicesByName() {
      if (this.sortedInvoicesByName == true) {
        this.invoices.sort((a, b) => (a.buyer.first_name + " " + a.last_name > b.buyer.first_name + " " + b.buyer.last_name ? -1 : 1));
      } else {
        this.invoices.sort((a, b) => (a.buyer.first_name + " " + a.buyer.last_name > b.buyer.first_name + " " + b.buyer.last_name ? 1 : -1));
      }
      this.sortedInvoicesByName = this.sortedInvoicesByName == true ? false : true;
      this.resetInvoiceList();
    },

    sortInvoicesByEmail() {
      if (this.sortedInvoicesByEmail == true) {
        this.invoices.sort((a, b) => (a.buyer.email > b.buyer.email ? -1 : 1));
      } else {
        this.invoices.sort((a, b) => (a.buyer.email > b.buyer.email ? 1 : -1));
      }
      this.sortedInvoicesByEmail = this.sortedInvoicesByEmail == true ? false : true;
      this.resetInvoiceList();
    },

    sortInvoicesByOrgNumber() {
      if (this.sortedInvoicesByOrgNumber == true) {
        this.invoices.sort((a, b) => (a.organizationNumber > b.organizationNumber ? -1 : 1));
      } else {
        this.invoices.sort((a, b) => (a.organizationNumber > b.organizationNumber ? 1 : -1));
      }
      this.sortedInvoicesByOrgNumber = this.sortedInvoicesByOrgNumber == true ? false : true;
      this.resetInvoiceList();
    },

    formatMoney(price, currency) {
      return common.formatMoney(price, common.toUpperCase(currency));
    },

    showViewOrderModal(invoiceId) {
      this.selectedOrderToView = this.invoices.find((payment) => payment.id == invoiceId);
      this.$bvModal.show("view-order-modal");
    },

    hideViewOrderModal() {
      this.selectedOrderToView = null;
      this.$bvModal.hide("view-order-modal");
    },
  },
  computed: {
    LangConstants() {
      return Constants;
    },

    getReadableStartDate() {
      if (this.customerSubscription != null) {
        return common.unixToReadableTime(this.customerSubscription.last_paid);
      }
      return "";
    },

    getReadableEndDate() {
      if (this.customerSubscription != null) {
        return common.unixToReadableTime(this.customerSubscription.expiry);
      }
      return "";
    },

    dayjs() {
      return dayjs;
    },
  },

  components: {
    DashboardItem,
    MyInput,
    MyButton,
    Pagination,
    NoDataBox,
    OrderList,
  },
};
</script>

<style lang="scss" scoped>
.btn-inline-text {
  white-space: nowrap;
}
</style>
